import { render, staticRenderFns } from "./RecordRemarkDialog.vue?vue&type=template&id=3ceaf068&scoped=true"
import script from "./RecordRemarkDialog.vue?vue&type=script&lang=js"
export * from "./RecordRemarkDialog.vue?vue&type=script&lang=js"
import style0 from "./RecordRemarkDialog.vue?vue&type=style&index=0&id=3ceaf068&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ceaf068",
  null
  
)

export default component.exports